import { Link } from "@inertiajs/react";
import AppShell from "../../components/Shell/AppShell";
import { pick } from "../../lib/i18n";
import type { CurrentUser, ModelPersonaSummary, ProductSummary } from "../../types";

const copy = {
  pl: {
    title: "Persony modeli", subtitle: "Zarządzaj presetami wyglądu osoby używanymi w generacji lifestyle.",
    newPersona: "+ Nowa persona", noPersonas: "Brak person", noPersonasHint: "Utwórz pierwszą personę, żeby kontrolować wygląd osoby w kadrze.",
    inactive: "nieaktywna", skinTone: "Odcień skóry",
  },
  en: {
    title: "Model personas", subtitle: "Manage person appearance presets used in lifestyle generation.",
    newPersona: "+ New persona", noPersonas: "No personas", noPersonasHint: "Create your first persona to control the person's appearance in frame.",
    inactive: "inactive", skinTone: "Skin tone",
  },
};

type Props = {
  personas: ModelPersonaSummary[];
  current_user: CurrentUser;
  products?: ProductSummary[];
};

export default function PersonasIndex({ personas, current_user, products = [] }: Props) {
  const initials = current_user.name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  const canEdit  = current_user.role === "admin" || current_user.role === "moderator";
  const t = pick(copy);

  return (
    <AppShell products={products} user={{ name: current_user.name, initials, role: current_user.role }}>
      <div className="page">
        <div className="page-hd">
          <div>
            <h2>{t.title}</h2>
            <p>{t.subtitle}</p>
          </div>
          {canEdit && (
            <div className="right">
              <Link href="/personas/new" className="btn btn-primary btn-sm">{t.newPersona}</Link>
            </div>
          )}
        </div>

        {personas.length === 0 ? (
          <div className="empty">
            <h4>{t.noPersonas}</h4>
            <p>{t.noPersonasHint}</p>
            {canEdit && (
              <Link href="/personas/new" className="btn btn-primary btn-sm" style={{ marginTop: 16 }}>
                {t.newPersona}
              </Link>
            )}
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 10 }}>
            {personas.map((persona) => (
              <Link key={persona.id} href={`/personas/${persona.id}`} style={{ textDecoration: "none" }}>
                <div className="panel" style={{ cursor: "pointer", transition: "border-color .12s" }}>
                  <div className="panel-body" style={{ padding: "10px 12px" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)", letterSpacing: "-0.01em" }}>
                        {persona.name}
                      </span>
                      {!persona.active && (
                        <span
                          className="mono"
                          style={{ fontSize: 9.5, color: "var(--muted-2)", background: "var(--bg-3)", padding: "2px 5px", borderRadius: 2 }}
                        >
                          {t.inactive}
                        </span>
                      )}
                    </div>
                    <div className="mono" style={{ fontSize: 10.5, color: "var(--muted-2)", marginTop: 3 }}>
                      {t.skinTone} {persona.skin_tone}/10 · {persona.age_band.replace("_", "-")}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
